import { useContext, useState, useEffect, createContext, useMemo } from 'react';
import { UserContext } from './UserContext';
import { useConfigContext } from './ConfigContext';
import { getApiBaseUrl } from '../utils/apiBase';

export const GetAllColumnContext = createContext(null);
function GetAllColumnContextProvider(props) {
  const { isDirectConfigScreen = false, children } = props;
  const STANDARD_VIEW = 'Standard View';
  const [tableDetails, setTableDetails] = useState(null);
  const [accessDetails, setAccessDetails] = useState(null);
  const [allColumns, setAllColumns] = useState(null);
  const [allDropdowns, setAllDropdowns] = useState(null);
  const [allAccessibleColumns, setAllAccessibleColumns] = useState(null);
  const [viewData, setViewData] = useState(null);
  const [initialViewColumns, setInitialViewColumns] = useState(null);
  const [selectedView, setSelectedView] = useState(null);
  const [selectedViewName, setSelectedViewName] = useState(null);
  const [changeHandler, setChangeHandler] = useState(null);
  const [allRows, setAllRows] = useState(null);
  const [reRender, setReRender] = useState(1);
  const [customReRender, setCustomReRender] = useState(1);
  const [dDCollector, setDDCollector] = useState({});
  const [tableFeatureData, setTableFeatureData] = useState({});
  const [customConfig, setCustomConfig] = useState({});
  const { userDetails } = useContext(UserContext);
  const [tabMenu, setTabMenu] = useState(0);
  const [rightPanelTabMenu, setRightPanelTabMenu] = useState(0);
  const [reportModal, setReportModal] = useState(null);
  const { configSchema } = useConfigContext();
  const apiBase = getApiBaseUrl();

  useEffect(() => {
    if (tableDetails?.id && allColumns) {
      getDropdownColumnsQuery();
    }
  }, [tableDetails?.id, allColumns]);
  useEffect(() => {
    if (userDetails?.userId && tableDetails?.id && !isDirectConfigScreen) {
      getViewManagerData();
      getScreenFeatureData();
    }
  }, [userDetails, tableDetails]);

  useEffect(() => {
    if (Object.keys(dDCollector).length) {
      setAllDropdowns(dDCollector);
    }
  }, [dDCollector]);

  const updateTableDetails = (obj) => {
    setTableDetails(obj);
  };
  const updateAccessDetails = (data) => {
    setAccessDetails(data);
  };
  const setStateAllColumnData = async (data) => {
    setAllColumns(data);
  };
  const setStateAllRowsData = async (data) => {
    setAllRows(data);
  };
  const setStateAllAccessibleColumnData = async (data) => {
    setAllAccessibleColumns(data);
  };
  const setStateViewManagerData = async (data) => {
    setViewData(data);
  };
  const updatereRender = () => {
    setReRender((prestate) => prestate + 1);
  };
  const updateCustomReRender = () => {
    setCustomReRender((prestate) => prestate + 1);
  };
  const updateDDCollector = (obj) => {
    setDDCollector((prestate) => {
      return { ...prestate, ...obj };
    });
  };
  const updateCustomConfig = (obj) => {
    setCustomConfig((prestate) => {
      return { ...prestate, ...obj };
    });
  };
  const setStateTableFeatureData = async (data) => {
    setTableFeatureData(data);
  };

  const updateTabMenuDetails = async (data) => {
    setTabMenu(data);
  };
  const updateRightTabMenuDetails = async (data) => {
    setRightPanelTabMenu(data);
  };
  const updateReportModal = async (data) => {
    setReportModal(data);
  };

  const getViewManagerData = async () => {
    try {
      const response = await fetch(
        `${apiBase}/api/viewManagerListService?screenGridId=${tableDetails?.id}&userId=${userDetails.userId}`,
      );
      const result = await response.json();
      if (result != undefined) {
        const data = result[`${configSchema}_mbd_view_manager`];
        setViewData(data);
      }
    } catch (error) {
      return error;
    }
  };

  const getDropdownColumnsQuery = async () => {
    if (allColumns) {
      try {
        const dropdownsInfo = allColumns
          .filter(
            (item) => item.attrDataType === 'singleSelect' || item.attrDataType === 'multiSelect',
          )
          .filter((item) => item.mbdDropdownConfig)
          .map((item) => ({
            attrDropdownId: item.attrDropdownId,
            attrInternalName: item.attrInternalName,
          }));
        if (!dropdownsInfo.length) {
          setAllDropdowns({});
          return;
        }
        const params = new URLSearchParams();
        dropdownsInfo.forEach((item) => params.append('attrDropdownId', item.attrDropdownId));

        const dropdownResp = await fetch(`${apiBase}/api/allDropdownDetails?${params}`);
        const dropdownDetails = await dropdownResp.json();

        if (dropdownDetails.length) {
          dropdownDetails?.forEach(({ id, data, tableKey }) => {
            const matchingColumn = dropdownsInfo.filter((col) => col.attrDropdownId === id);
            matchingColumn.forEach((col) => {
              const obj = {};
              obj[col.attrInternalName] = data[tableKey];
              updateDDCollector(obj);
            });
          });
        }
      } catch (error) {
        return error;
      }
    }
  };

  const getScreenFeatureData = async () => {
    const nonActionKey = ['rows_per_page', 'singledataset_header', 'singledatasetgroup_header'];
    try {
      const response = await fetch(
        `${apiBase}/api/screenGridActionsFeatureDetails?screenGridId=${tableDetails?.id}`,
      );
      const result = await response.json();
      const obj = result?.[`${configSchema}_mbd_screen_grid_feature`]?.reduce((resp, item) => {
        resp[item.mbdFeatureConfig.featureName] = item.mbdFeatureConfig;
        return resp;
      }, {});
      const arr = Object.keys(obj).filter((item) => !nonActionKey.includes(item));
      if (arr.length) {
        obj.action = {
          featureName: 'action',
          featureValue: { featureNameen: null, featureNamede: null, featureValue: '' },
        };
      }
      setTableFeatureData(obj);
    } catch (error) {
      return error;
    }
  };

  const value = useMemo(
    () => ({
      STANDARD_VIEW,
      allColumns,
      allAccessibleColumns,
      viewData,
      selectedViewName,
      changeHandler,
      selectedView,
      initialViewColumns,
      allDropdowns,
      setAllDropdowns,
      allRows,
      reRender,
      customReRender,
      accessDetails,
      tableDetails,
      tableFeatureData,
      customConfig,
      tabMenu,
      rightPanelTabMenu,
      reportModal,
      isDirectConfigScreen,

      getViewManagerData,
      setStateAllColumnData,
      setStateAllAccessibleColumnData,
      setStateViewManagerData,
      setSelectedViewName,
      setChangeHandler,
      setSelectedView,
      setInitialViewColumns,
      setStateAllRowsData,
      updatereRender,
      updateCustomReRender,
      updateAccessDetails,
      updateTableDetails,
      updateCustomConfig,
      setStateTableFeatureData,
      updateTabMenuDetails,
      updateRightTabMenuDetails,
      updateReportModal,
    }),
    [
      STANDARD_VIEW,
      allColumns,
      allAccessibleColumns,
      viewData,
      selectedViewName,
      changeHandler,
      selectedView,
      initialViewColumns,
      allDropdowns,
      setAllDropdowns,
      allRows,
      reRender,
      accessDetails,
      tableDetails,
      tableFeatureData,
      customConfig,
      tabMenu,
      rightPanelTabMenu,
      reportModal,
      customReRender,
      isDirectConfigScreen,

      getViewManagerData,
      setStateAllColumnData,
      setStateAllAccessibleColumnData,
      setStateViewManagerData,
      setSelectedViewName,
      setChangeHandler,
      setSelectedView,
      setInitialViewColumns,
      setStateAllRowsData,
      updatereRender,
      updateCustomReRender,
      updateAccessDetails,
      updateTableDetails,
      updateCustomConfig,
      setStateTableFeatureData,
      updateTabMenuDetails,
      updateRightTabMenuDetails,
      updateReportModal,
    ],
  );
  return <GetAllColumnContext.Provider value={value}>{children}</GetAllColumnContext.Provider>;
}

export default GetAllColumnContextProvider;

// Create a hook to use the APIContext, this is a Kent C. Dodds pattern
export function useColumnContextAPI() {
  const context = useContext(GetAllColumnContext);
  if (!context) {
    throw new Error('Context must be used within a Provider');
  }
  return context;
}
